var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExoeriencesPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4993 10.8333V16.6667C17.4993 17.1269 17.1263 17.5 16.666 17.5H3.33268C2.87245 17.5 2.49935 17.1269 2.49935 16.6667V10.8333H1.66602V9.16667L2.49935 5H17.4993L18.3327 9.16667V10.8333H17.4993ZM4.16602 10.8333V15.8333H15.8327V10.8333H4.16602ZM3.36569 9.16667H16.633L16.133 6.66667H3.86569L3.36569 9.16667ZM4.99935 11.6667H11.666V14.1667H4.99935V11.6667ZM2.49935 2.5H17.4993V4.16667H2.49935V2.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExoeriencesPeople);
export default __webpack_public_path__ + "static/media/exoeriencesPeople.9e39a0213a82cf171572658af1e14731.svg";
export { ForwardRef as ReactComponent };